var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewGames({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6736_1704)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6736_1704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.765 9.7898L13.6734 8.01903L11.9713 3.77261C11.8567 3.48035 11.3983 3.48035 11.2779 3.77261L9.57593 8.01903L5.48424 9.7898C5.3467 9.85284 5.25501 9.99038 5.25501 10.1508C5.25501 10.3113 5.3467 10.4488 5.48424 10.5119L9.57593 12.2826L11.2779 16.5291C11.3352 16.6723 11.4728 16.7697 11.6218 16.7697C11.7708 16.7697 11.9083 16.6781 11.9656 16.5291L13.6676 12.2826L17.7593 10.5119C17.8968 10.4488 17.9885 10.3113 17.9885 10.1508C17.9885 9.99038 17.8968 9.85284 17.7593 9.7898H17.765ZM7.99427 4.33421L5.35817 3.42304L4.48138 0.689515C4.37822 0.374328 3.87393 0.374328 3.77077 0.689515L2.89398 3.42304L0.25788 4.33421C0.103152 4.38579 0 4.53479 0 4.70671C0 4.87863 0.103152 5.02189 0.25788 5.0792L2.89398 5.99038L3.77077 8.7239C3.82235 8.88436 3.96562 8.98751 4.12607 8.98751C4.28653 8.98751 4.4298 8.87863 4.48138 8.7239L5.35817 5.99038L7.99427 5.0792C8.149 5.02762 8.25215 4.87863 8.25215 4.71244C8.25215 4.54625 8.149 4.39725 7.99427 4.33994V4.33421ZM6.49284 14.4546L4.98567 13.9331L4.48138 12.3686C4.37822 12.0534 3.87393 12.0534 3.77077 12.3686L3.26648 13.9331L1.75931 14.4546C1.60458 14.5061 1.50143 14.6551 1.50143 14.8271C1.50143 14.999 1.60458 15.1422 1.75931 15.1995L3.26648 15.721L3.77077 17.2855C3.82235 17.446 3.96562 17.5491 4.12607 17.5491C4.28653 17.5491 4.4298 17.4402 4.48138 17.2855L4.98567 15.721L6.49284 15.1995C6.64756 15.148 6.75072 14.999 6.75072 14.8328C6.75072 14.6666 6.64756 14.5176 6.49284 14.4603V14.4546Z",
    fill: "#8C8989"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6736_1704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6736_1704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17.1003,
    fill: "white",
    transform: "translate(0 0.449219)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewGames);
export default __webpack_public_path__ + "static/media/NewGames.a21b4f6537ce68534fe65901c3ff5c20.svg";
export { ForwardRef as ReactComponent };